








































import {Emit, Prop} from "vue-property-decorator";
import {InOut} from 'vue-inout-prop-decorator';
import {Component, Vue} from '@/shared/component';

import {Achat} from '@/models';

import CrudAchatEditAchatFrais from '@/components/Crud/Achat/EditAchatFrais.vue';

@Component({
	components: {
		CrudAchatEditAchatFrais,
	}
})
export default class CrudAchatEditDialogAchatFrais extends Vue {
	@InOut({ type: Achat  , isVModel: true }) private value!: Achat;

	@Emit()
	private onSubmit(achat: Achat) {
		this.onClose();
	}

	@Emit()
	private onClose() {
		this.value = null;
	}
}
